import { Box, Chip, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import PersonIcon from '../../icons/PersonIcon';
import { HeaderAppBar, HeaderToolbar, ProfileBox } from './style';
import ResponsiveNav from './ResponsiveNav';
import { useAuth } from '../../hooks/useAuth';
import logo from '../../assets/logo/PrimeLogo.svg';
import logo360 from '../../assets/logo/PRIME360WhiteLogo.svg';
import AccountMenu from './AccountMenu';
import Notifications from './Notifications';
import Intercom from '@intercom/messenger-js-sdk';

function Header({displayDetails}) {
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    useEffect(() => {
        // Intercom({
        //     app_id: 'xs8rskx8',
        //     user_id: userDetails.contact.id, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
        //     name: userDetails.contact.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
        //     email: userDetails?.contact?.email, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
        //     created_at: Math.floor(new Date('2024-01-01').getTime() / 1000),
        //     user_hash: userDetails?.contact?.contactHash,
        // });
    }, []);
    const theme = useTheme();
    return (
        <HeaderAppBar elevation={0}>
            <HeaderToolbar>
                <ResponsiveNav displayDetails={displayDetails} />
                <Box>
                    <img src={logo360} height={32} width={105} alt="Logo" />
                </Box>
                {userDetails.tokens.idToken.payload['email'] !== userDetails.contact.email && (
                    <Chip sx={{ backgroundColor: '#ec8c17' }} label={`Logged in as ${userDetails.contact.email}`} color="warning" />
                )}
                <Box>
                    <Notifications />
                    <AccountMenu />
                </Box>
            </HeaderToolbar>
        </HeaderAppBar>
    );
}

export const ProfileBoxUI = ({ sx = {}, iconSx = {} }) => {
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();

    const theme = useTheme();

    const userDetails = () => {
        let userDetails = getUserDetailsNotAsync();
        return { name: userDetails?.contact?.name, email: userDetails?.contact?.email };
    };
    return (
        <ProfileBox
            sx={{
                ...sx,
            }}
        >
            <Box
                component={'img'}
                src="/images/avatars/avatar_2.jpg"
                alt="avatar"
                sx={{
                    width: '1.5rem',
                    height: '1.5rem',

                    borderRadius: theme.typography.borderRadius.round, //50%

                    display: {
                        xs: 'block',
                        sm: 'none',
                    },
                    marginRight: theme.typography.generic.xxxSmall,
                }}
            />
            <PersonIcon
                sx={{
                    color: '#F55187',
                    width: '1.2rem',
                    height: '1.2rem',
                    marginRight: '0.2rem',
                }}
            />
            <span>{userDetails()?.name}</span>
            {/* <ProfileIconBox
                sx={{
                    ...iconSx,
                }}
            >
                <span className="text">{userDetails?.businessList[0].roles ? userDetails?.businessList[0].roles : 'Not defined'}</span>
            </ProfileIconBox> */}
        </ProfileBox>
    );
};

export default Header;
